/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Payment_Method_Failed_TitleInputs */

const en_dialog_payment_method_failed_title = /** @type {(inputs: Dialog_Payment_Method_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid Payment Method`)
};

const ar_dialog_payment_method_failed_title = /** @type {(inputs: Dialog_Payment_Method_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طريقة دفع غير صالحة`)
};

const de_dialog_payment_method_failed_title = /** @type {(inputs: Dialog_Payment_Method_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültige Zahlungsmethode`)
};

const es_dialog_payment_method_failed_title = /** @type {(inputs: Dialog_Payment_Method_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forma de pago no válida`)
};

const fr_dialog_payment_method_failed_title = /** @type {(inputs: Dialog_Payment_Method_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode de paiement invalide`)
};

const it_dialog_payment_method_failed_title = /** @type {(inputs: Dialog_Payment_Method_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metodo di pagamento non valido`)
};

const ja_dialog_payment_method_failed_title = /** @type {(inputs: Dialog_Payment_Method_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効なお支払い方法です`)
};

const ko_dialog_payment_method_failed_title = /** @type {(inputs: Dialog_Payment_Method_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잘못된 결제 수단`)
};

const pt_br_dialog_payment_method_failed_title = /** @type {(inputs: Dialog_Payment_Method_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Método de pagamento inválido`)
};

const ru_dialog_payment_method_failed_title = /** @type {(inputs: Dialog_Payment_Method_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неверный способ оплаты`)
};

const th_dialog_payment_method_failed_title = /** @type {(inputs: Dialog_Payment_Method_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิธีการชำระเงินไม่ถูกต้อง`)
};

const tr_dialog_payment_method_failed_title = /** @type {(inputs: Dialog_Payment_Method_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geçersiz Ödeme Yöntemi`)
};

const zh_cn_dialog_payment_method_failed_title = /** @type {(inputs: Dialog_Payment_Method_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付款方式无效`)
};

const zh_tw_dialog_payment_method_failed_title = /** @type {(inputs: Dialog_Payment_Method_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付款方式無效`)
};

/**
* | output |
* | --- |
* | "Invalid Payment Method" |
*
* @param {Dialog_Payment_Method_Failed_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_payment_method_failed_title = /** @type {((inputs?: Dialog_Payment_Method_Failed_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Payment_Method_Failed_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_payment_method_failed_title(inputs)
	if (locale === "ar") return ar_dialog_payment_method_failed_title(inputs)
	if (locale === "de") return de_dialog_payment_method_failed_title(inputs)
	if (locale === "es") return es_dialog_payment_method_failed_title(inputs)
	if (locale === "fr") return fr_dialog_payment_method_failed_title(inputs)
	if (locale === "it") return it_dialog_payment_method_failed_title(inputs)
	if (locale === "ja") return ja_dialog_payment_method_failed_title(inputs)
	if (locale === "ko") return ko_dialog_payment_method_failed_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_payment_method_failed_title(inputs)
	if (locale === "ru") return ru_dialog_payment_method_failed_title(inputs)
	if (locale === "th") return th_dialog_payment_method_failed_title(inputs)
	if (locale === "tr") return tr_dialog_payment_method_failed_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_payment_method_failed_title(inputs)
	return zh_tw_dialog_payment_method_failed_title(inputs)
});